import { Link } from "react-router-dom";
import './Home.css';
import { useEffect , useState} from "react";
import axios from "axios";
import { Card } from "react-bootstrap";
import { Col, Row } from "react-bootstrap";
/*https://fontawesome.com/search */
import { FaRegistered, FaCartShopping, FaPerson, FaCalculator, FaChartSimple} from "react-icons/fa6";
import { useContext } from "react";
import UserContext from "../utils/UserContext";

const api_url = process.env.REACT_APP_API_URL;

export default function Home() {

    const user = useContext(UserContext);

    const version = "1.3.2";

    let [pingMessage, setPingMessage] = useState('pending');
    useEffect(() => {
        axios.get(api_url)
            .then(res => {
                setPingMessage('success');
            })
            .catch(err => {
                console.error('error al conectar a la api',err);
                setPingMessage('error');
            })
    }, [])

    return <>
        <Card className="mb-2" bg="dark" text="light">
            <Card.Body><h2>Bienvenido <span className="user">{user.login?user.nombre_apellido:""}</span> al CRM del Grupo Carrabs</h2></Card.Body>
        </Card>
        <nav>
            <Row>
                <Col sm="4" className="mb-2">
                    <Link to="/datos">
                        <Card bg="secondary">
                            <Card.Body>
                                <Card.Title>
                                    <FaRegistered></FaRegistered>
                                </Card.Title>
                                <Card.Text>Datos</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col sm="4" className="mb-2">
                    <Link to="/pedidos">
                        <Card bg="secondary">
                            <Card.Body>
                                <Card.Title>
                                    <FaCartShopping></FaCartShopping>
                                </Card.Title>
                                <Card.Text>Pedidos</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col sm="4" className="mb-2">
                    <Link to="/crm">
                        <Card bg="secondary">
                            <Card.Body>
                                <Card.Title>
                                    <FaPerson></FaPerson>
                                </Card.Title>
                                <Card.Text>CRM</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col sm="2"></Col>
                <Col sm="4" className="mb-2">
                    <Link to="/ranking">
                        <Card bg="secondary">
                            <Card.Body>
                                <Card.Title>
                                    <FaCalculator></FaCalculator>
                                </Card.Title>
                                <Card.Text>Ranking</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col sm="4" className="mb-2">
                    <Link to="/estadistica">
                        <Card bg="secondary">
                            <Card.Body>
                                <Card.Title>
                                    <FaChartSimple></FaChartSimple>
                                </Card.Title>
                                <Card.Text>Estadística</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
            </Row>
        </nav>
        <p className={pingMessage}>
            {pingMessage=='pending'?'Conectando a crm-carrabs-api. Version '+version:''}
            {pingMessage=='success'?'Conectado a crm-carrabs-api. Version '+version:''}
            {pingMessage=='error'?'Sin conexión a crm-carrabs-api. Version '+version:''}
        </p>
    </>
        
}